<template>
    <div class="supplier-info">
        <strong v-if="!qualificationList.length">商品资质已存在，无需填写</strong>
        <!-- 商品检测报告 不需要校验 -->
        <template v-else>
            <div
                v-for="(qualification, idx) in qualificationList"
                :key="idx"
            >
                <xx-form
                    :ref="`form-${idx}`"
                    :model="qualification"
                    label-width="130px"
                    label-suffix="："
                    class="max-width-750 w-full"
                >
                    <p class="view-standard">
                        <!-- 去查看的地址是后端接口返回的 -->
                        不清楚资质填写标准？
                        <xx-link :path="qualificationSupportUrl">
                            去查看
                        </xx-link>
                    </p>
                    <qualification-status
                        :manufacturer-id="qualification.manufacturerId"
                        :manufacturer-name="qualification.manufacturerName"
                    />
                    <template v-if="qualification.existed">
                        资质已存在
                    </template>
                    <template v-else>
                        <xx-form-item
                            v-for="(qItem, index) in qualification.items"
                            :key="qItem.qualificationType"
                            :label="qualificationTypeMap[qItem.qualificationType]"
                            class="is-required"
                        >
                            <qualification-item
                                :p-idx="idx"
                                :item="qItem"
                                :index="index"
                                :need-valid="true"
                            />
                        </xx-form-item>
                    </template>
                </xx-form>
            </div>
        </template>
    </div>
</template>

<script>
import emitter from 'utils/emitter';
import { createNewToken, supplierInfoToken } from '../shareState';
import { getBaseModel } from '../baseModel';
import QualificationItem from './item';
import QualificationStatus from '../../qualificationStatus';
// import { mockData } from '../config';

const baseModel = getBaseModel();

// 非进口资质
const unImportQualificatesTmp = () => [
    {
        qualificationType: 14,
        pictures: [],
        rejectedDisabledAttr: 'qualificationPhysicalPic',
        desc: '上传在售商品的全部可视面照片，且标签上的文字、图标均清晰可识别',
    },
    {
        idNumber: '',
        qualificationType: 13,
        longTerm: false,
        validTimeStart: -1,
        validTimeEnd: -1,
        pictures: [],
        rejectedDisabledAttr: 'qualificationInspectionReport',
        desc: '<span>1、第三方检测报告须含CMA章且完整、在效期内，与新建品匹配，标称生产单位与绑定生产商匹配</span><br/><span>2、快检报告完整、在效期内，与新建品匹配，与绑定供应商匹配</span>',
    },
];

// 进口资质字段
const importQualificatesTmp = () => [
    {
        qualificationType: 14,
        pictures: [],
        rejectedDisabledAttr: 'qualificationPhysicalPic',
        desc: '上传在售商品的全部可视面照片，且标签上的文字、图标均清晰可识别',
    },
    {
        idNumber: '',
        qualificationType: 15,
        longTerm: false,
        validTimeStart: -1,
        validTimeEnd: -1,
        pictures: [],
        rejectedDisabledAttr: 'qualificationDeclaration',
        desc: '报关单与入境检疫证明为一组同批次商品资质，包含新建品且在有效期内',
    },
    {
        idNumber: '',
        qualificationType: 16,
        longTerm: false,
        validTimeStart: -1,
        validTimeEnd: -1,
        pictures: [],
        rejectedDisabledAttr: 'qualificationEntryQuarantineCertificate',
        desc: '报关单与入境检疫证明为一组同批次商品资质，包含新建品且在有效期内',
    },
];

const qualificationTypeMap = {
    13: '商品检测报告',
    14: '实物图',
    15: '商品报关单',
    16: '入境检疫证明',
};

export default {
    name: supplierInfoToken,
    components: {
        QualificationItem,
        QualificationStatus,
    },
    mixins: [emitter],
    data() {
        return {
            config: [],
            qualificationList: [], // 各供应生产商模型
            models: {}, // 前3个tab的数据
            hasQualification: false, // 供应商生产商已有资质，则不需要填写资质
            qualificationTypeMap,
            qualificationSupportUrl: '',
        };
    },
    computed: {
        // 提报信息数据
        createInfoModel() {
            return this.models.applyInfoSection || {};
        },
        // citysSku() {
        //     return this.createInfoModel.cityIds;
        // },
        // 获取当前提报城市的加工状态
        currentCitySkuType() {
            return this.createInfoModel.skuType;
        },
        // 当前提报城市的加工状态：原料/成品
        isMaterialOrFinished() {
            return this.currentCitySkuType === 1 || this.currentCitySkuType === 2;
        },
        // 基础信息
        baseInfoModel() {
            return this.models.skuBaseSection || {};
        },
        // 是否进口
        isImportFlag() {
            return +this.baseInfoModel.importFlag === 1;
        },
    },
    created() {
        baseModel.registerVM(this, supplierInfoToken);
    },
    async activated() {
        await this.initState();
        this.dispatch(createNewToken, 'page-loaded', true);
        this.getMisRequiredAndDefaultSkuType();
    },
    methods: {
        async initState() {
            // 进入第四步，直接重新请求，这样可以避免一些不必要的判断，简化数据流
            const draft = await this.fetchNewCreateData(baseModel.models.applyId);
            baseModel.setData(draft);
            const supplierInfo = baseModel.initSupplierInfo;

            this.models = baseModel.data;
            const citySaleInfoList = ((this.models.citySkuManageSection || {}).citySkuManageInfo || []);

            // 根据经营城市的 供应商和生产商 计算出有几个不同的 资质
            // 如果接口存在数据，则进行一次merge
            // 如果销售城市有变动，则后续内容重置，简单处理
            this.qualificationList = this.genQualificationList(citySaleInfoList);

            // 详情数据回显的填充
            if (supplierInfo && supplierInfo.length) {
                this.qualificationList.forEach((qItem) => {
                    supplierInfo.some((info) => {
                        // 通过供应商+生产商，唯一确定资质
                        if (qItem.manufacturerId === info.manufacturerId) {
                            if (info.items) {
                                // tmpItem指的是 importQualificatesTmp模板中的item
                                qItem.items = qItem.items.map((tmpItem) => {
                                    // 从接口资质数据中找与模板资质类型相同的数据，如果没有则使用默认的模板资质数据 tmpItem
                                    let resObj = info.items.find((i) => i.qualificationType === tmpItem.qualificationType);
                                    if (resObj) {
                                        // 补充关键字段
                                        resObj.rejectedDisabledAttr = tmpItem.rejectedDisabledAttr || null;
                                        resObj.pictures = resObj.pictures || []; // 防止未Null
                                        resObj.desc = tmpItem.desc;
                                    } else {
                                        resObj = tmpItem;
                                    }
                                    return resObj;
                                });
                            }
                            return true;
                        }
                        return false;
                    });
                });
            }
        },
        async fetchNewCreateData(applyId) {
            const draftData = await this.$service.fetchNewSellDetail({ applyId });
            return draftData;
        },
        getVMPostData() {
            return this.qualificationList;
        },
        /**
         * 资质逻辑：
         * 1. 城市，加工类型是 成品/原料
         * 2. 根据供应商，生产商唯一确认一个资质，如果生产商不存在，则用供应商
         * 3. 该供应商和生产商 没有不存在已有资质
         */
        genQualificationList(citySaleInfoList) {
            // 全部无资质供应商列表
            // const list = citySaleInfoList.filter((item) => this.judgeSkuTypeIsMaterialOrFinished(item.cityId) && !item.isSupplierExistQualification);
            // if (!list.length) return [];
            // 供应商和生产商唯一去重
            const arr = window._.uniqWith(citySaleInfoList, (val, othval) => `${val.supplierId}${val.manufacturerId || ''}` === `${othval.supplierId}${othval.manufacturerId || ''}`).map((item) => ({
                supplierId: item.supplierId,
                supplierName: item.supplierName,
                manufacturerId: item.manufacturerId,
                manufacturerName: item.manufacturerName,
                items: this.isImportFlag ? importQualificatesTmp() : unImportQualificatesTmp(),
            }));
            return arr;
        },
        // judgeSkuTypeIsMaterialOrFinished(cityId) {
        //     const target = this.createInfoModel.cityIds.find((item) => item === cityId);
        //     if (!target) return '';
        //     // return target.skuType === 1 || target.skuType === 2;
        //     return this.createInfoModel.skuType === 1
        // },
        async validate() {
            if (!this.qualificationList.length) return true;
            let validResult = false;
            try {
                const valids = await Promise.all(this.qualificationList.map((item, idx) => this.$refs[`form-${idx}`][0].validate()));
                validResult = valids.every((valid) => valid === true);
            } catch (error) {
                // pass
            }
            return validResult;
        },
        //  获取去查看的URL
        getMisRequiredAndDefaultSkuType() {
            const obj = {
                mgCategoryId: this.createInfoModel.categoryId, // 暂时用管理
                bgCategoryId: this.createInfoModel.bgCategoryId,
                needQueryField: {
                    requireQualificationSupportUrl: true,
                },
            };
            this.$service.getMisRequired(obj).then((res) => {
                if (res && res.flowSpecByMgCategoryInfo) {
                    this.qualificationSupportUrl = res.flowSpecByMgCategoryInfo.qualificationSupportUrl;
                }
            });
        },
    },
};
</script>

<style scoped lang="scss">
.supplier-info {
    margin-top: 40px;
    min-height: 500px;
}
.toggle-btn {
    text-align: center;
    cursor: pointer;
}
.max-width {
    max-width: 1200px;
}
/deep/ .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus {
    border-color: #EB2F3C !important;
}
.max-width-750 {
    max-width: 750px;
}
.w-full {
    width: 100%;
}
.view-standard{
    color: #95989e;
    font-size: 12px;
    padding-left: 60px;
}
</style>
